import { useEffect, useState } from 'react';

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const usePagination = () => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setPage(1);
  }, [pageSize]);

  return {
    page,
    pageSize,
    totalCount,
    setTotalCount,
    setPage,
    setPageSize,
  };
};

export default usePagination;
